var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuestNoShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 2.5H20C20.5523 2.5 21 2.94772 21 3.5V19.5C21 20.0523 20.5523 20.5 20 20.5H4C3.44772 20.5 3 20.0523 3 19.5V3.5C3 2.94772 3.44772 2.5 4 2.5ZM5 4.5V18.5H19V4.5H5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 10454"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 314",
    x1: 7.70711,
    y1: 7.29289,
    x2: 16.3431,
    y2: 15.9289,
    stroke: "#FF0000",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 10455"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 314_2",
    x1: 7.69231,
    y1: 15.9289,
    x2: 16.3283,
    y2: 7.29287,
    stroke: "#FF0000",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestNoShow);
export default __webpack_public_path__ + "static/media/guestNoShow.60c4552024030fdc3d12e54bc1b14b90.svg";
export { ForwardRef as ReactComponent };